import type { PropsWithChildren } from 'react';
import ErrorPage from '../components/ErrorPage';
import { STAFF_ROUTES } from '../constant/routes';
import { useCurrentUserAuth } from '../hooks/useCurrentUserAuth';
import { MSR3BaseLayout } from '../layout/MSR3BaseLayout';
import { userIsDeniedCustomerView } from '../utils/helpers/common';

/** Guards the route, not `MSR3BaseLayout`, so the v2 and v3 shells both get it. */
export const RequireCustomerViewForStaff = ({
  children,
}: PropsWithChildren) => {
  const { currentUser } = useCurrentUserAuth();

  if (userIsDeniedCustomerView(currentUser)) {
    // Shelled like WorkspaceRedirect's denial. Profile variant: it has the Go
    // Back link, and omits the nav that would name the workspace just refused.
    // The logo needs the same treatment -- it otherwise points at the workspace
    // route that just refused, and every other one refuses too (the guard is
    // keyed on identity, and `/` resolves to another customer's workspace).
    return (
      <MSR3BaseLayout
        sidebarLogoHref={STAFF_ROUTES.dashboard}
        sidebarVariant="profile"
      >
        <ErrorPage notAuthorized />
      </MSR3BaseLayout>
    );
  }

  return <>{children}</>;
};
